import React, { useState, useEffect } from "react";
import { collection, query, where, getDocs, getDoc } from "firebase/firestore";
import { db } from "../firebase"; // Import your Firebase configuration
import { Container, Row, Button, Col } from "react-bootstrap";
//import { motion } from "framer-motion";
//import { motion, AnimatePresence } from "framer-motion";
import { useInView } from "react-intersection-observer";
import ImageEditTitle from "./ImageEditTitle";

const GuestArtistsList = () => {
  const [guestArtists, setGuestArtists] = useState([]);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const [ref, inView] = useInView();

  useEffect(() => {
    const fetchGuestArtists = async () => {
      try {
        // Reference to the artists collection
        const artistsCollection = collection(db, "artists");

        // Create a query to filter artists with role "guestArtist"
        const q = query(artistsCollection, where("role", "==", "guestArtist"));
        const q2 = query(artistsCollection, where("role", "==", "member"));

        // Fetch the documents that match the query
        const querySnapshot = await getDocs(q);
        const querySnapshot2 = await getDocs(q2);

        // Initialize an array to store the guest artists
        const guestArtistsData = [];
        const members = [];

        // Members Loop throught and extract data
        for (const doc2 of querySnapshot2.docs) {
          const votersData = doc2.data();
          members.push({
            first_name: votersData.first_name,
            //rating: ratingData.rating,
          });
          setMembers(members);
          console.log("Member FirstName", votersData.first_name);
          console.log("From member Array FirstName", members[0].first_name);
          console.table("Members array:", members);
        }

        // Loop through the query snapshot and extract data
        for (const doc of querySnapshot.docs) {
          const artistData = doc.data();

          // Fetch the totalRating for the artist from their ratings subcollection
          const artistRatingsRef = collection(doc.ref, "ratings"); // Use collection() here
          const artistRatingsSnapshot = await getDocs(artistRatingsRef);
          let totalRating = 0;
          const voters = []; // Array to store individual voters

          artistRatingsSnapshot.forEach((ratingDoc) => {
            const ratingData = ratingDoc.data();
            totalRating += ratingData.rating || 0;

            // Collect individual voters
            voters.push({
              userId: ratingData.userId,
              rating: ratingData.rating,
              displayName: ratingData.displayName,
            });
          });
          // Sort the voters array in descending order based on rating
          //voters.sort((a, b) => b.totalRrating - a.totalRating);
          // Add the totalRating and voters to the artist's data
          artistData.totalRating = totalRating;
          artistData.voters = voters;

          guestArtistsData.push(artistData);
        }
        guestArtistsData.sort((a, b) => b.totalRating - a.totalRating);
        // Set the guest artists in the component's state
        setGuestArtists(guestArtistsData);
        setLoading(false); // Update loading state
      } catch (error) {
        console.error("Error fetching guest artists:", error);
        setLoading(false); // Update loading state in case of an error
      }
    };

    fetchGuestArtists();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Container className='mt-3'>
      <Row>
        <h1 className='mt-3 mb-4'>Voting Results for Guest Artists</h1>
      </Row>

      <Row className='mb-3' style={{ justifyContent: "space-between" }}>
        {guestArtists.map((artist) => (
          <>
            {/* begin framer-motion */}

            <Col
              lg={"3"}
              md={"4"}
              xs={"12"}
              key={artist.id}
              className='text-center one-pix-border'>
              <div>
                <h3 className='mt-4'>
                  {artist.first_name} {artist.last_name}
                </h3>
                <a
                  className='all-artists-link mb-4'
                  href={`mailto:${artist.email}`}>
                  {artist.email}
                </a>
                {/* <ImageEditTitle
                  key={artist.id}
                  imageUrl={artist.imageURLs[0]}
                  initialTitle='Your Image Title'
                /> */}
                {/* <img
                  className='one-pix-border img-fluid'
                  src={artist.imageURLs[0]}
                  alt={`${artist.id}`}
                  loading='lazy'
                /> */}
                <div className='jumbo-container'>
                  <div className='jumbo-text'>{artist.totalRating}</div>
                </div>
                <p>Votes by Member</p>
                <div className='text-center mb-3'>
                  {artist.voters.map((voter, index) => (
                    <>
                      <h6 key={index}>
                        {voter.displayName} rating: {voter.rating}
                      </h6>{" "}
                    </>
                  ))}
                </div>{" "}
              </div>{" "}
            </Col>
          </>
        ))}
      </Row>
    </Container>
  );
};

export default GuestArtistsList;
